import React from "react";
import "./list.css";
import { Link } from "react-router-dom";

const List = ({ items }) => {
  
  return (
    <div className="list-container">
      <ul className="list">
        {items.map((item, index) => (
          <li key={index}>
            <Link to={item.to}>
              <div className="list-item">
                {
                  item.label && item.instalation ? (
                    <>
                      <p className="list-item-model">{item.model}</p>
                      <p className="list-item-instalation">{item.instalation}</p>
                    </>
                  ) : (
                    <p className="list-item-model">{item.label}</p>
                  )
                }
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default List;